/**
 * Trilha de auditoria (redesign admin, Fase 5). Puro e sem I/O: filtros e
 * rótulos de apresentação sobre `PlatformAuditEvent[]` do event store. A tela é
 * somente leitura — a trilha é append-only, nada aqui altera ou apaga evento.
 */
import type { PlatformAuditEvent } from "../api/types.js";

export type AuditActorFilter = PlatformAuditEvent["actorType"] | "todos";

export const ACTOR_LABELS: Record<PlatformAuditEvent["actorType"], string> = {
  customer: "Cliente",
  human: "Operador",
  ai: "IA",
  system: "Sistema"
};

function fold(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
}

/** Busca por tipo de evento, agregado, ator ou correlação; filtro de ator; mais recente primeiro. */
export function filterAuditEvents(events: PlatformAuditEvent[], query: string, actor: AuditActorFilter): PlatformAuditEvent[] {
  const needle = fold(query);
  return events
    .filter((event) => {
      if (actor !== "todos" && event.actorType !== actor) return false;
      if (!needle) return true;
      return [event.eventType, event.aggregateType, event.aggregateId, event.actorId ?? "", event.correlationId].some((value) =>
        fold(value).includes(needle)
      );
    })
    .sort((a, b) => b.occurredAt.localeCompare(a.occurredAt));
}

export function actorCounts(events: PlatformAuditEvent[]): Record<PlatformAuditEvent["actorType"], number> {
  const counts = { customer: 0, human: 0, ai: 0, system: 0 };
  for (const event of events) counts[event.actorType] += 1;
  return counts;
}
